import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as core from '../../../core'
import * as common from '../../common'
import { FsFunction as _FsFunction } from '../../common/fs-function'

import { Mapping } from './mapping'
import { Rule } from './rule'

/**
 * TODO:
 */
export interface Record {
  id: Record.Id
  attributes?: Record.Attribute[]
  originalMapping?: Mapping
  applicableRuleIds: Rule.Id[]
  fsFunction?: Record.FsFunction
}
export namespace Record {
  export const isRecord = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.object<Record>({
      applicableRuleIds: TypeChecker.Factory.list(Rule.Id.isId),
      attributes: TypeChecker.Factory.optional(
        TypeChecker.Factory.list(Record.Attribute.isAttribute),
      ),
      fsFunction: FsFunction.isFsFunction,
      id: Id.isId,
      originalMapping: TypeChecker.Factory.optional(Mapping.isMapping),
    }),
  )

  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId: TypeChecker<Id> = TypeChecker.Factory.lazy(
      () => core.dms.data.Record.Id.isId,
    ).usingAlias('rate.gl.Record')
    export const assertIsId = TypeAsserter.Factory.from(isId)
  }

  export interface Attribute {
    id: core.dms.models.Attribute.Id
    value?: core.common.value.Raw
  }
  export namespace Attribute {
    // TODO: This seems to be failing in some cases
    export const isAttribute = TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.object<Attribute>({
        id: core.dms.models.Attribute.Id.isId,
        value: core.common.value.Raw.isRaw,
      }),
    )
  }

  /**
   * Retrieves a {@link Mapping} from the given {@link Record} (requiring a
   * lookup of {@link Rule})
   */
  export function getMapping(
    record: Record,
    rulesLookup: Partial<
      globalThis.Record<string | number, Pick<Rule, 'mapping' | 'priority'>>
    >,
  ): Mapping | undefined {
    const sortedMappings = record.applicableRuleIds
      .map(ruleId => rulesLookup[ruleId])
      .filter(TypeChecker.isNotNullish.raw)
      .sort((a, b) => a.priority - b.priority)
      .map(rule => rule.mapping)

    return Mapping.combine(...sortedMappings) ?? record.originalMapping
  }

  /**
   * Only the properties of an {@link _FsFunction FS function} that are relevant
   * for a {@link Record}
   *
   * NOTE: {@link FsFunction.faFunctionCategorization} is included because we
   * use that to determine the default IDC functionalization of a record
   */
  // TODO: maybe get rid of this
  export type FsFunction = Pick<_FsFunction, 'id' | 'faFunctionCategorization'>
  export namespace FsFunction {
    export const isFsFunction = TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.object<FsFunction>({
        faFunctionCategorization: TypeChecker.Factory.optional(
          common.FaFunction.Categorization.Ids.isIds,
        ),
        id: _FsFunction.Id.isId,
      }),
    )
  }
}
